module.exports = __webpack_public_path__ + "static/media/Chris Esezobor.847da16b.jpeg";